import { type AbstractControl, type ValidationErrors, type ValidatorFn } from '@angular/forms'
import { type CantonId } from '../services/appointments.service'

export function licencePlateCHMaxLengthValidator (canton: CantonId | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const maxLength = canton === 'ZH' ? 7 : 6

    if (control?.value && control?.value?.length > maxLength) {
      return { maxlength: { requiredLength: maxLength, actualLength: control.value.length } }
    }

    return null
  }
}
